export const FORM_FIELDS = {
  ssn: null,
  email: 'email',
  email2: 'email',
  preferred_locale: null,
  first_name: null,
  middle_name: null,
  last_name: null,
  name_suffix: null,
  address_1: null,
  address_2: null,
  city: null,
  state: null,
  zip_code: null,
  country: null,
  home_phone: 'tel',
  work_phone: 'tel',
  cell_phone: 'tel',
  gender: null,
  marital_status: null,
  is_smoker: null,
  employee_number: null,
  employee_type: null,
  subscriber_code: null,
  business_title: null,
  shareholder: null,
  owner: null,
  division: null,
  org_class: null,
  location: null,
  employment_level: null,
  highly_compensated: null,
  current_salary: null,
  benefit_salary: null,
  benefit_salary2: null,
  benefit_salary3: null,
  benefit_salary4: null,
  benefit_salary5: null,
  benefit_salary6: null,
  pay_rate: null,
  union_code: null,
  hours_per_week: null,
  hire_date: null,
  original_hire_date: null,
  benefits_start_date: null,
  birthdate: null,
  original_effective_date: null,
  status_ends_on_expected: null,
  termination_date: null,
  seniority_date: null,
  is_voluntary_termination: null,
  vip: null,
  ee_code: null,
  bank_account_type: null,
  bank_routing_number: null,
  bank_account_number: null,
  written_language: null,
  spoken_language: null,
  udef_1: null,
  udef_2: null,
  udef_3: null,
  udef_4: null,
  udef_5: null,
  udef_6: null,
  udef_7: null,
  udef_8: null,
  udef_9: null,
  udef_10: null,
  udef_11: null,
  udef_12: null,
  udef_13: null,
  udef_14: null,
  udef_15: null,
  udef_16: null,
  udef_17: null,
  udef_18: null,
  udef_19: null,
  udef_20: null,
  udef_21: null,
  udef_22: null,
  udef_23: null,
  udef_24: null,
  udef_25: null,
  udef_26: null,
  udef_27: null,
  udef_28: null,
  udef_29: null,
  udef_30: null,
  test_employee: null,
  org_payroll_id: null,
  pay_type: null,
  hide_from_payroll: null,
  change_effective_date: null,
  anthem_emp_dep_code: null,
  anthem_member_code: null,
  anthem_hcid: null,
  anthem_sub_id: null,
  medicare_effective_date: null,
  medicare_termination_date: null,
  medicare_plan: null,
  medicare_reason: null,
  communication_mode: null,
  receive_text_messages: null,
  aca_paper_form_opt_out: null,
  sin: null,
};
